
import Chart from "../../../assets/outline/Chart.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ChartIcon({ className, dataTestid = "ChartIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Chart data-testid={dataTestid} className={classes} {...rest} />
  );
}
